import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import pageContext from '@bingads-webui-static-legacy/page-context';
import BudgetView from '@bingads-webui-campaign-legacy/budget/view/budget';
import template from '@bingads-webui-campaign-legacy/budget/template/budget-panel.pug';
import ViewModel from '@bingads-webui-campaign-legacy/budget/viewmodel/budget-panel';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize(options = {}) {
    let self = this;

    self.options = options;

    self.koModel = new ViewModel({
      Amount: self.model.Amount,
      AccountCurrencyCode: pageContext.AccountCurrencyCode,
      isEditing: false,
    });

    self.budgetView = new BudgetView({
      model: self.model,
      initBudget: options.initBudget,
      haveBudgetSuggestion: options.haveBudgetSuggestion,
      languages: options.languages,
      campaignId: options.campaignId,
      activity: options.activity,
      isForVNext: options.isForVNext,
      activityLogger: options.activityLogger,
    });

    self.budgetView.on('budget.updated', (dailyBudget) => {
      self.trigger('budget.updated', dailyBudget);
    });
  }

  get events() {
    return {
      'click .link-edit > a': 'expandEditor',
    };
  }

  render() {
    this.$el.html(template({ i18n }));
    ko.applyBindings(this.koModel, this.el);
    this.$('.budget-editor').empty().append(this.budgetView.render().el);
    return this;
  }

  update(model) {
    if (_.isUndefined(model.Amount)) {
      // If there is no budget amount, then we should prompt the user for it instead of displaying a blank panel
      if (_.isUndefined(this.koModel.amount())) {
        this.koModel.isEditing(true);
      }
    } else {
      this.koModel.amount(decimal.fromFloatToString(model.Amount));
    }

    this.budgetView.update(model);
  }

  updateSuggestedBudget(adGroups, fromBudgetUpdate) {
    this.budgetView.updateSuggestedBudget(adGroups, fromBudgetUpdate);
  }

  validate() {
    return this.budgetView.validate();
  }

  getValues() {
    return this.budgetView.ko_model.toObject();
  }

  expandEditor() {
    this.koModel.isEditing(true);
  }

  enough() {
    return this.budgetView.enough();
  }

  getSuggestedBudget() {
    return this.budgetView.getSuggestedBudget();
  }
}
